import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { ValueConverter } from '@angular/compiler/src/render3/view/template';

@Component({
  template: `
     <form [formGroup]="formEdit" >
      <mat-dialog-content>
        <mat-form-field>
          <mat-select placeholder={{fieldName}} (selectionChange)="changedvalue($event.value)" [value]="selectedLocation" >
            <mat-option *ngFor="let loc of content" [value]="loc" >{{loc}}</mat-option>
          </mat-select>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button  (click)="save()">OK</button>
      </mat-dialog-actions>
    </form>
  `,
  styleUrls: ['./combo-dialog.component.css']
})

export class ComboDialogComponent implements OnInit {
  formEdit: FormGroup;
  fieldName: string;
  content: string[];
  fieldType: number;
  selectedLocation: string;
  constructor(private formBuilder: FormBuilder,
              private dialogRef: MatDialogRef<ComboDialogComponent>,
              @Inject(MAT_DIALOG_DATA) private data) {
    this.fieldName = data.fieldName;
    this.content = data.content;
    this.fieldType = data.fieldType;
   }

  ngOnInit(): void {
    this.formEdit = this.formBuilder.group({content: [this.content], fieldName: this.fieldName, fieldType: this.fieldType});
  }

  save() {
    this.formEdit.value.content = this.selectedLocation ;
    this.dialogRef.close(this.formEdit.value);
  }

  changedvalue(v) {
    this.selectedLocation = v;
  }

}


